import Model, { attr } from '@ember-data/model';

export default class AirbnbQualityListingModel extends Model {
  @attr('number') listingId!: number;
  @attr('string') externalId!: string;
  @attr('string') nickname!: string;
  @attr('string') hostName!: string;
  @attr('string') city!: string;
  @attr('string') country!: string;
  @attr('string') cancellationPolicy!: string;
  @attr('boolean') nonRefundableDiscount!: boolean;
  @attr('string') qualityStatus!: string;
  @attr('number') qualityPercentage!: number | null;
  @attr('boolean') isGuestFavourite!: boolean;
  @attr('boolean') isSuperHost!: boolean;
  @attr('boolean') missingCheckoutTasks!: boolean;
  @attr('number') overallRating!: number;
  @attr('number') cleanliness!: number;
  @attr('number') accuracy!: number;
  @attr('number') communication!: number;
  @attr('number') checkin!: number;
  @attr('number') location!: number;
  @attr('number') value!: number;
  @attr('number') fiveStarReviewPercentage!: number | null;
  @attr('array') positiveReviewTags!: string[];
  @attr('array') negativeReviewTags!: string[];
  @attr('array') topReservationIssues!: string[];
  @attr('array') topCustomerServiceIssues!: string[];
  @attr('array') topCancellationIssues!: string[];
  @attr('number') totalBookings!: number;
  @attr('number') totalReviews!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-quality-listing': AirbnbQualityListingModel;
  }
}
